import React from 'react'
import { Block } from '@xprog/prensa'

const ColunaGiro = (props) => {

  const blockProps = {
    fontFamily: '$primary',
    fontWeight: 400,
    fontSize: '21px',
    lineHeight: '32px',
    px: '$0',
    py: '$0',
    width: '100%',
    '.colunagiro-container': {
      align: ['column', 'left', 'top'],
      '@lg': {
        align: ['column', 'left', 'top'],
      },
      'h2': {
        fontSize: '26px !important',
        fontWeight: 700,
        lineHeight: '43px',
        mb: '25px !important',
        '@lg': {
          mb: '21px !important',
        },
      },
      '.colunagiro-header': {
        align: ['column', 'left', 'top'],
        '.left': {
          fontSize: '21px !important',
          fontWeight: 700,
          lineHeight: '32.5px',
          color: 'black',
          mb: '5px',
        },
        '.right': {
          fontSize: '16px !important',
          fontWeight: 400,
          lineHeight: '21px',
          color: 'black',
          mb: '5px'
        },
        '@lg': {
          width: '100%',
          align: ['row', 'between', 'bottom'],
          borderBottom: '2px solid #BFBFBF'
        },
      },
      '.colunagiro-body': {
        width: '100%',
        'img': {
          width: '100%',
        },
        '@lg': {
          align: ['row', 'left', 'top'],
          'img': {
            width: '296px',
            mr: '33px',
            mb: '48px'
          },
          'h3': {
            fontSize: '28px !important',
            fontWeight: 700,
            lineHeight: '33px',
            color: 'black',
            mb: '5px'
          },
        },
        '.p-smartcaption': {
          display: 'none',
        },
      },
    }
  }

  return (
    <Block css={blockProps}>
      <div dangerouslySetInnerHTML={{ __html: props.content }} />
    </Block>
  )
}

export default ColunaGiro